import React from "react";
import styles from "./expense-filter.module.scss";
import { Autocomplete, Field, Filter, DateRange, Button } from "components/commons";
import { locale } from "localization/en";
import { expenseType } from "data/constant/expense-type";
import SearchTypeField from "components/commons/search-field/search-type";
import { Path } from "enums";
import { useRouter } from "hooks";

const ExpenseFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const dateBy = [
    { label: locale.shiftDate, value: "shift" },
    { label: locale.expenseDate, value: "expense" },
  ];

  const searchType = [
    { label: locale.expenseId, value: "expenseId" },
    { label: locale.remarks, value: "remarks" },
  ];

  const router = useRouter();

  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          close={resetFilter}
          clear={applyClearFilter}
          submit={() => {
            applyFilter();
          }}
          filterCount={filterCount}
        >
          <Field
            label={locale.filterDateBy}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="dateType"
              value={filterState.dateType}
              options={dateBy}
              onChange={(name, { value }) => {
                modifyFilter({ [name]: value });
              }}
              disableClearable={true}
            />
          </Field>
          <Field
            className={styles.date}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.date}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({ startDate, endDate });
              }}
            />
          </Field>
          <Field
            label={locale.expenseType}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="type"
              value={filterState.type.value}
              options={expenseType}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({
                  [name]: {
                    value,
                    isSelectedAll,
                  },
                });
              }}
              multiple
              hasAll
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchTypeField
            placeholder={locale.keyword}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={searchType}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            // startIcon={<span className="icon-download" />}
            exportButton
            onClick={() => router.push(Path.AddExpense)}
          >
            {locale.addExpense}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default ExpenseFilter;
